import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
// import DropArea from "./DropArea/DropArea";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import QBHeader from "./QBHeader";
import { loadQuestionDetails } from "../../../Redux/actions/questionTranslationAction";
import { Backdrop } from "@mui/material";
import { resetQuestionState } from "../../../Redux/reducers/questionTranslationSlice";
import QuestionPropertiesModalWrapper from "./QuestionProperties/QuestionPropertiesModalWrapper";
import { QBArea } from "../question.style";
import DropArea from "../DropArea/DropArea";
import Loader from "../../Common/assets/Loader";

type props = {
  studyId?: string;
  formId: string;
  type: "platform" | "study";
};
const QuestionBuilderTranslation = ({ studyId, formId, type }: props) => {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get("lang");
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.questionTranslation.loading);
  const toggle = useAppSelector(
    (state) => state.questionTranslation.translationToggle,
  );

  useEffect(() => {
    if (studyId && formId && lang) {
      dispatch(loadQuestionDetails(studyId, formId, lang, type));
    }
    return () => {
      dispatch(resetQuestionState());
    };
  }, [dispatch, studyId, formId, lang, type, toggle]);

  return (
    <div className="preview-wrapper">
      {loading && (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      )}

      <QBHeader />
      <QBArea>
        <DropArea />
        <QuestionPropertiesModalWrapper />
      </QBArea>
    </div>
  );
};

export default QuestionBuilderTranslation;
